<mat-card>
  <h2 translate>sidenav.menu.users.operationSearch</h2>
  <mat-card-content>
    <form [formGroup]="searchOperationForm" (ngSubmit)="searchOperation()">
      <div fxFlex fxLayout="row wrap" class="form-wrapper">
        <!-- ROW -->
        <div fxFlex="50" fxFlex.gt-sm="35">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>operationSearch.operationNumber</mat-label>
            <input
              id="operationNumberOperationSearch"
              #operationNumber
              #operationNumberOperationSearch
              formControlName="operationNumber"
              (keypress)="numberOnly($event, operationNumber)"
              matInput
              autocomplete="off"
            />
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.gt-sm="35">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>search.input.documentId</mat-label>
            <input
              id="nifNieOperationSearch"
              #nifNieOperationSearch
              formControlName="nifNie"
              matInput
              type="text"
              maxlength="9"
              autocomplete="off"
            />
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="30">
          <div class="operation-search__submit">
            <button
              id="searchOperationSearch"
              color="accent"
              type="submit"
              mat-flat-button
              [disabled]="searchButtonDisabled"
              (click)="onSearchButtonClick()"
            >
              <span translate>request.button.consult</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
<scf-request-panel
  *ngFor="let operations of operationsByStateList"
  [isMainPanel]="true"
  [state]="setState(operations.idStatus)"
  [isSpecificSearch]="true"
  [specificSearchOperations]="operations.operations"
  (viewRequest)="keepFilterSearch()"
  (keepSearch)="keepFilterSearch()"
  class="operation-search__panel"
>
</scf-request-panel>
